import React, { useContext } from "react";
import "./Work.css";
import Upwork from "../../img/tailwindcss.jpg";
import Fiverr from "../../img/html-icon.png";
import Amazon from "../../img/react-js.jpg";
import Shopify from "../../img/js-logo.jpg";
import Facebook from "../../img/nextjs-icon.png";
import { motion } from "framer-motion";

// import { Link } from "react-scroll";
import { themeContext } from "../../Context";

const Work = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="works">
      {/* left side */}
      <div className="w-left ">
        <div className="awesome">
          {/* dark Mode */}
          <span style={{ color: darkMode ? "white" : "" }}>How I work!</span>
          <span>What I use in my projects!</span>
          <spane className="ta">
            As a developer, I always try to give quality to the code I write by
            following best programming practices.
            
            I avoid using the well-known open source CMS (WordPress, Joomla,
            etc...) which I think is best suited to those who do not know the
            programming.
            
            I prefer to embed my code to get new custom features for every need.
            
            When developing web sites, I use tried and true libraries for the
            most common tasks or a web framework.
           
            The latter is a software able to facilitate the writing of more
            robust and maintainable code by emphasizing good programming
            practices such as code reuse, object oriented programming and design
            patterns.
            
            For the development of the user interface, I use NEXT JS, HTML, CSS,
            JavaScript and the React JS library. Also, to make the project more
            practical and faster, I use Bootstrap.
            
            When it comes to the heartbeat of my projects, I use PHP, which has
            raised its quality and security standards.
            
            Moreover, it is compatible with any type of server and can be
            integrated with other software.
            
            Finally, for relational database management and data storage, I use
            MySQL.
          </spane>
          <br/> <br/>
          {/* <Link to="contact" smooth={true} spy={true}> */}
          {/* <button className="button s-button">Hire Me</button> */}
          {/* </Link> */}
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>

        {/* right side */}
      </div>
      <div className="w-right">
        {/* <div className="w-mainCircle"> */}
        <motion.div
          initial={{ rotate: 45 }}
          whileInView={{ rotate: 0 }}
          viewport={{ margin: "-40px" }}
          transition={{ duration: 3.5, type: "spring" }}
          className="w-mainCircle"
        >
          <div className="w-secCircle">
            <img src={Upwork} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Fiverr} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Amazon} alt="" />
          </div>{" "}
          <div className="w-secCircle">
            <img src={Shopify} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Facebook} alt="" />
          </div>
        </motion.div>
        {/* background Circles */}

        {/* <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div> */}
      </div>
    </div>
  );
};

export default Work;
